import { useCallback, useEffect, useState } from "react";

// Minimal localStorage-backed auth hook for the ta7arorr_front app.
// Exposes { user, login, logout } and keeps state in sync with localStorage.
export function useAuth() {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  });

  const login = useCallback((u, token) => {
    try {
      if (token) localStorage.setItem("token", token);
      if (u) localStorage.setItem("user", JSON.stringify(u));
      setUser(u || null);
    } catch (e) {
      // ignore
    }
  }, []);

  const logout = useCallback(() => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } catch (e) {
      // ignore
    }
    setUser(null);
  }, []);

  useEffect(() => {
    const onStorage = () => {
      try {
        const raw = localStorage.getItem("user");
        setUser(raw ? JSON.parse(raw) : null);
      } catch (e) {
        setUser(null);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const token = localStorage.getItem("token");
  const API_BASE = "http://localhost:5000/api"; // Hardcoded for now or use env
  return { user, token, login, logout, API_BASE };
}
